import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { DateIso } from '@/shared/types';
import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type EducationGeneralFormType = PersonalIdentifierGeneralFormType;

export const EducationGeneralSection: EducationGeneralFormType = {
  ...commonGeneralFields,
};

export type EducationDetailsDto = Omit<PersonalIdentifierDetails, 'createdAt' | 'updatedAt'> & {
  educationalInstitutionName?: string;
  educationStartDate?: DateIso;
  educationEndDate?: DateIso;
  idObtainingDate?: DateIso;
  registrationNumber?: string;
};

type EducationDetailsHelp = {
  educationalInstitutionName: QuestionType.TEXT;
  educationStartDate: QuestionType.DATE_TIME;
  educationEndDate: QuestionType.DATE_TIME;
  idObtainingDate: QuestionType.DATE_TIME;
  registrationNumber: QuestionType.TEXT;
};

export type EducationDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  | 'dateOfIssue'
  | 'endDate'
  | 'gender'
  | 'birthDate'
  | 'placeOfBirth'
  | 'issuerCode'
  | 'basisForIssuingId'
  | 'other'
> &
  TDtoWrapper<EducationDetailsDto, EducationDetailsHelp>;

export const EducationDetailsSection: EducationDetailsFormType = {
  educationalInstitutionName: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:education.inputs.educationalInstitutionName.label',
    value: '',
    capitalized: true,
    order: -1,
  },
  educationStartDate: {
    type: QuestionType.DATE_TIME,
    label: 'forms_personal_ids:education.inputs.educationStartDate.label',
    order: 2,
  },
  educationEndDate: {
    type: QuestionType.DATE_TIME,
    label: 'forms_personal_ids:education.inputs.educationEndDate.label',
    order: 2,
  },
  idObtainingDate: {
    type: QuestionType.DATE_TIME,
    label: 'forms_personal_ids:education.inputs.idObtainingDate.label',
    order: 2,
  },
  registrationNumber: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:education.inputs.registrationNumber.label',
    value: '',
    capitalized: true,
    order: 2,
  },
  ...omit(
    commonDetailsFields,
    'dateOfIssue',
    'endDate',
    'gender',
    'birthDate',
    'placeOfBirth',
    'issuerCode',
    'basisForIssuingId',
    'other',
  ),
};

export const EducationLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const EducationFormSections = [
  EducationGeneralSection,
  EducationDetailsSection,
  EducationLegalizedCopiesSection,
];
